
import React, { useEffect, useState } from "react";
import { Row, Col, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Nav from '../../components/breadcrumb';
import { ErrorLoading, PageLoading } from "../../components/loading";
import PageHeader, { Title } from '../../components/pageheader';
// import { UCWords } from "../../components/resources";
import SelectInput from "../../components/select";
import { errorAlert, successAlert } from "../../components/toastr";
import { CancelButton, SubmitButton } from "../../components/btns";
import { appModules, permissionLevels } from "../../assets/constants";
import { getUserPermissions, updateUserPermissions } from "../../resources/api/users";


/**
 * 
 * @param {Object} props
 * @param {import("./view-users").UserObject} props.details
 * @param {React.Dispatch<React.SetStateAction<import("./view-users").UserObject>} props.setDetails
 */
const UserPermissions = ({ details, setDetails }) => {

    const { Label } = Form;

    const navigate = useNavigate();

    const nav_items = [
        { title: 'Users', href: "/app/users" },
        { title: details.display_name, href: `/app/users/${details.id}` },
        { title: "Permissions" }
    ]

    const [validated, setValidated] = useState(false);
    const [isSubmitting, setSubmitting] = useState(false);

    /**
     * handle the overall submitting of the form
     * @param {React.FormEvent} e
     */
    const handleSubmit = e => {
        const form = e.currentTarget;

        e.preventDefault();

        if (!form.checkValidity()) {
            setValidated(true);
            errorAlert("You have errors in your form. These have been highlighted for you.", "Form Errors");
            return;
        }

        setValidated(false);
        setSubmitting(true);

        let promise = updateUserPermissions(permissions, details.id);

        promise
            .then(({ message, user }) => {
                successAlert(message);
                navigate(`/app/users/${details.id}`);
            })
            .catch(err => {
                errorAlert(err);
                setSubmitting(false);
            })

    }

    const [permissions, setPermissions] = useState({});
    const [isLoaded, setLoaded] = useState(false);
    const [error, setError] = useState();

    useEffect(() => {

        setLoaded(false);
        setError(null);

        getUserPermissions(details.id)
            .then(({ permissions }) => {

                setPermissions(permissions);
            })
            .catch(err => setError(err))
            .finally(() => setLoaded(true));

    }, [details.id])

    //load events details

    if (!isLoaded) {
        return <PageLoading />
    }

    if (error) return <ErrorLoading>{error}</ErrorLoading>

    return (
        <>
            <Nav items={nav_items} />

            <PageHeader maxWidth="1000">
                <Title>{details.display_name}'s Permissions</Title>
            </PageHeader>

            <Form className="max-1000" validated={validated} noValidate onSubmit={handleSubmit}>
                <h4 className="form-section-label">Modules</h4>
                <Row className="g-2">
                    {
                        appModules.map(m => (
                            <Col sm={6} className="my-1" key={m}>
                                <Label className="form-field-title fw-bold">{m.replace(/_/g, " ").toUpperCase()}</Label>
                                <SelectInput
                                    maxItems={6}
                                    options={permissionLevels.map(pl => ({ title: pl.toUpperCase(), id: pl }))}
                                    placeholder="Select an option"
                                    value={permissions[m] || []}
                                    onChange={permissions => setPermissions(p => ({ ...p, [m]: permissions }))}
                                />
                            </Col>
                        ))
                    }
                </Row>

                <Row>
                    <Col className="mt-5 mb-3 text-end">
                        <SubmitButton isSubmitting={isSubmitting} type="submit">
                            Update Permissions
                        </SubmitButton>
                        <CancelButton isSubmitting={isSubmitting}>
                            Cancel
                        </CancelButton>
                    </Col>
                </Row>
            </Form>
        </>
    )

}



export default UserPermissions;